import { useState } from 'react';
import Card from '@/components/Card';
import Header from './Header';
import { isEmpty } from '@/utils/misc';
import { useInvestor, useInvestorCompanies } from '@/hooks/useStore';
import TabMessage from '@/components/TabMessage';
import CompanyInvestorsTable from '@/components/CompanyInvestorsTable';
import { renderProfileName } from '@/utils/strings';
import { classes, filterCompanies } from './utils';

export type InvestorCompaniesCardProps = {
  isFetchingData?: boolean;
  investorId: number;
};

export default function InvestorCompaniesCard({
  isFetchingData,
  investorId,
}: InvestorCompaniesCardProps) {
  const investor = useInvestor(investorId);
  const companies = useInvestorCompanies(investorId);
  const [search, setSearch] = useState('');

  const renderCompanies = () => {
    // TODO: Make sure the latest financial report has been fetched for each company
    if (isEmpty(companies)) {
      return (
        <TabMessage
          message={`No companies specified for ${renderProfileName(investor!.profile)}.`}
        />
      );
    }
    const filtered = filterCompanies(search, companies);
    if (isEmpty(filtered)) {
      return <TabMessage message="No companies matching current search." />;
    }
    return (
      <CompanyInvestorsTable
        isFetchingData={isFetchingData}
        rowType="company"
        rows={filtered}
      />
    );
  };

  if (!investor) return null; // TODO

  return (
    <Card className={classes.card}>
      <Header
        investorId={investorId}
        search={search}
        onSearch={(update) => setSearch(update)}
      />
      <div className={classes.section}>{renderCompanies()}</div>
    </Card>
  );
}
